import React, { Component } from 'react';
import Nav from 'components/common/Nav';
import { withRouter } from 'react-router-dom';
import { Grid, Button, Row, Col, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { load, clearSuccess, loadRows, getTotal } from './ducks/actions';
import { InfiniteLoader, AutoSizer, Column, Table } from 'react-virtualized';
import './style.css';
import 'react-virtualized/styles.css';
export class CustomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleDismiss = this.handleDismiss.bind(this);
    this.isRowLoaded = this.isRowLoaded.bind(this);
    this.loadMoreRows = this.loadMoreRows.bind(this);
  }
  componentDidMount() {
    this.props.actions.getTotal();
    this.props.actions.load();
  }
  handleDismiss() {
    this.props.actions.clearSuccess();
  }

  isRowLoaded({ index }) {
    return !!this.props.data[index];
  }

  loadMoreRows({ startIndex, stopIndex }) {
    var limit = stopIndex - startIndex;
    this.props.actions.loadRows(startIndex, limit);
  }
  render() {
    var successMessage;
    if (this.props.success) {
      successMessage = (
        <Row>
          <Col xs={12}>
            <Alert
              bsStyle="success"
              className="chunk"
              onDismiss={this.handleDismiss}
            >
              {this.props.success}
            </Alert>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">
            <Grid fluid>
              <Row>
                <Col xs={12}>
                  <div className="page-header">
                    <span className="pull-right">
                      <Button
                        bsStyle="primary"
                        className="pull-right"
                        href="/company"
                      >
                        Create
                      </Button>
                    </span>
                    <h1>Companies</h1>
                  </div>
                </Col>
              </Row>
              {successMessage}
              <Row>
                <Col xs={12}>
                  <InfiniteLoader
                    isRowLoaded={this.isRowLoaded}
                    loadMoreRows={this.loadMoreRows}
                    rowCount={this.props.total}
                  >
                    {({ onRowsRendered, registerChild }) => (
                      <AutoSizer>
                        {({ height, width }) => {
                          return (
                            <Table
                              headerHeight={20}
                              width={width}
                              height={500}
                              rowCount={this.props.total}
                              rowHeight={50}
                              disableHeader={false}
                              rowGetter={({ index }) =>
                                this.props.data[index] || {}
                              }
                              onRowsRendered={onRowsRendered}
                              ref={registerChild}
                            >
                              <Column
                                label="ID"
                                dataKey="reference_id"
                                width={(width - 80) / 3}
                              />
                              <Column
                                label="Name"
                                dataKey="name"
                                width={((width - 80) * 2) / 3}
                              />

                              <Column
                                dataKey="id"
                                width={80}
                                cellRenderer={({ cellData }) => {
                                  var url = '/company/' + cellData;
                                  return (
                                    <Button
                                      bsStyle="primary"
                                      className="pull-right btn-sm"
                                      href={url}
                                    >
                                      Edit
                                    </Button>
                                  );
                                }}
                              />
                            </Table>
                          );
                        }}
                      </AutoSizer>
                    )}
                  </InfiniteLoader>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.companiesReducer.data,
    total: state.companiesReducer.total,
    success: state.companiesReducer.success
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      load: () => {
        dispatch(load());
      },
      getTotal: () => {
        dispatch(getTotal());
      },
      loadRows: (start, limit) => {
        dispatch(loadRows(start, limit));
      },
      clearSuccess: () => {
        dispatch(clearSuccess());
      }
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CustomerList)
);



// WEBPACK FOOTER //
// ./src/components/companies/CompanyList/index.js